import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { buttonClass, Card } from "../../../ui/index.js";
import { useCabinet } from "../../cabinet/index.js";
import { CopyField } from "../ShareLinks.js";
import { StepNav } from "../StepNav.js";
import type { StepProps } from "../types.js";

/**
 * Шаг 7: Instagram. Подключение на странице этапа 4 (`/settings/instagram`): профессиональный аккаунт
 * и «Войти через Instagram». Здесь же ссылки для шапки профиля: запись и уведомление о данных.
 */
export function InstagramStep({ state, next, back }: StepProps) {
  const { t } = useTranslation();
  const cab = useCabinet();
  return (
    <div>
      <p className="mb-4 text-ink-2">{t("onb.instagram.intro")}</p>
      <Card className="space-y-3">
        <ol className="list-decimal space-y-1 pl-5 text-sm text-ink-2">
          <li>{t("onb.instagram.step1")}</li>
          <li>{t("onb.instagram.step2")}</li>
        </ol>
        <Link to={`${cab.base}/settings/instagram`} className={buttonClass("primary", "w-full")}>
          {t("onb.instagram.connect")}
        </Link>
      </Card>
      <Card className="mt-4 space-y-3">
        <p className="text-sm text-ink-2">{t("onb.instagram.bio")}</p>
        <CopyField label={t("onb.links.booking")} value={state.bookingUrl} />
        <CopyField label={t("onb.links.notice")} value={state.noticeUrl} />
      </Card>
      <StepNav onBack={back} onNext={next} onSkip={next} nextLabel={t("onb.instagram.done")} />
    </div>
  );
}
